import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollSmoother } from 'gsap/ScrollSmoother'
import cloneDeep from 'lodash/cloneDeep'
import Vue from 'vue'

import scrollTo from '../../js/common/scroll-to'

gsap.registerPlugin(ScrollTrigger, ScrollSmoother)

export default {
  data() {
    const { calculatorDefaultState = {} } = window

    return {
      calculatorDefaultState,
      calculator: cloneDeep(calculatorDefaultState),
      calculatorErrors: {},
      currentStep: 0,
      isBusy: false,
      firstStepWithError: null,
    }
  },
  methods: {
    handleSubmit(e) {
      this.validate()

      if (typeof this.firstStepWithError === 'number') {
        this.currentStep = this.firstStepWithError
        Vue.nextTick(() => {
          this.refreshScrollTrigger('.text-xs.text-red')
        })
      } else if (this.isValid) {
        const submitObject = {
          ...this.calculator.step1,
          ...this.calculator.step2,
        }

        const form = e.target

        if (!this.isBusy && form.action) {
          this.isBusy = true
          fetch(form.action, {
            method: form.method || 'post',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(submitObject),
            redirect: 'follow',
          }).then(res => {
            this.isBusy = false
            if (!res.ok) {
              alert('Error. The form was not sent.')
            }
            if (res.redirected) {
              window.location.href = res.url
            }
          })
        }
      }
    },

    reset() {
      this.calculatorErrors = {}
      this.calculator = cloneDeep(this.calculatorDefaultState)
      this.currentStep = 0
      this.refreshScrollTrigger()
    },

    refreshScrollTrigger(selector = '#form-wrapp') {
      scrollTo(selector, 'top 200px')
    },

    validate() {
      const newErrors = {}

      this.firstStepWithError = null
      this.calculatorErrors = newErrors

      Object.keys(this.calculator).forEach((step, stepIndex) => {
        Object.keys(this.calculator[step]).forEach(key => {
          if (
            window.requiredFields?.[step][key] &&
            !this.calculator[step][key]
          ) {
            console.log(`error on step ${stepIndex}, field ${key}`)
            if (this.firstStepWithError === null) {
              this.firstStepWithError = stepIndex
            }
            newErrors[key] = true
          }
        })
      })

      this.calculatorErrors = newErrors
    },

    nextStep() {
      this.currentStep++
      this.refreshScrollTrigger()
    },
    prevStep() {
      if (this.currentStep > 0) this.currentStep--
      this.refreshScrollTrigger()
    },
  },
  computed: {
    isValid() {
      return Object.keys(this.calculatorErrors).length === 0
    },
  },
}
